export const updateHeaderNavigation = (headerNavigation, index) => {
  const updatedHeaderNavigation = headerNavigation.map((item, idx) => {
    const itemCopy = { ...item };
    itemCopy.active = idx === index;
    return itemCopy;
  });
  return updatedHeaderNavigation;
};
